import { render, staticRenderFns } from "./NodeRenderer.vue?vue&type=template&id=af7b71f0&"
import script from "./NodeRenderer.vue?vue&type=script&lang=ts&"
export * from "./NodeRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports